import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import PurchaseCreditNoteRegisterForm from '../components/PurchaseCreditNoteRegisterForm';
import { useGetPurchaseCreditNoteRegisterHandler } from '../dataHandlers/getPurchaseCreditNoteRegisterHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export default function PurchaseCreditNoteRegisterDetailsPage() {
  const { purchaseInvoiceRegister } = useTranslatedMessages();
  useDocumentTitle(
    purchaseInvoiceRegister?.pages?.details_title_credit_note ?? 'Purchase Credit Note Register Details',
  );
  const navigate = useNavigate();
  const { document_id } = useParams();
  const { register, isLoading } = useGetPurchaseCreditNoteRegisterHandler(document_id);

  useEffect(() => {
    if (!isLoading && register?.document_mode === 'E_INVOICE') {
      const documentId = register.uuid || register.id;
      navigate(`/purchases/documents/credit-notes/${documentId}`, { replace: true });
    }
  }, [isLoading, register, navigate]);

  if (isLoading || !register) {
    return <DocumentSkeletonForm />;
  }

  if (register.document_mode === 'E_INVOICE') {
    return <DocumentSkeletonForm />;
  }

  const onClickingBackButton = () => navigate('/purchase-invoice-register?tab=credit-notes');

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <PurchaseCreditNoteRegisterForm
        onSubmit={() => {}}
        onCancel={onClickingBackButton}
        initialData={register}
        readOnly
      />
    </Stack>
  );
}
